'use client'

// src/api/common/currency.ts
var CURRENCY_QUERY = `
id
title
symbol
code
`;

export {
  CURRENCY_QUERY
};
//# sourceMappingURL=chunk-PXTWVUHC.mjs.map